import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { APIClient } from "../../helpers/api_helper";
import { Spinner } from "reactstrap";

const apiClient = new APIClient();

const severityToClass = (severity) => {
  switch (severity) {
    case "warning":
      return "warning";
    case "success":
      return "success";
    case "info":
    default:
      return "info";
  }
};

const severityToIcon = (severity) => {
  switch (severity) {
    case "warning":
      return "ri-error-warning-line";
    case "success":
      return "ri-checkbox-circle-line";
    case "info":
    default:
      return "ri-information-line";
  }
};

const SuggestionsBlock = () => {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await apiClient.get("/dashboard/suggestions");
        const raw = response?.data ?? response;
        setSuggestions(Array.isArray(raw) ? raw : []);
      } catch (err) {
        setError(err?.message || "Failed to load suggestions");
        setSuggestions([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <Card className="card-height-100">
      <CardHeader>
        <h4 className="card-title mb-0">Insights & Suggestions</h4>
      </CardHeader>
      <CardBody>
        {loading ? (
          <div className="text-center py-4">
            <Spinner color="primary" />
          </div>
        ) : error ? (
          <div className="alert alert-danger mb-0">{error}</div>
        ) : suggestions.length === 0 ? (
          <p className="text-muted mb-0">No suggestions at the moment.</p>
        ) : (
          <ul className="list-unstyled mb-0">
            {suggestions.map((item, idx) => (
              <li
                key={idx}
                className={`alert alert-${severityToClass(item.severity)} alert-dismissible fade show d-flex align-items-start mb-2 py-2`}
                role="alert"
              >
                <i
                  className={`${severityToIcon(item.severity)} me-2 mt-1 fs-5`}
                  aria-hidden="true"
                />
                <span className="flex-grow-1">{item.message}</span>
              </li>
            ))}
          </ul>
        )}
      </CardBody>
    </Card>
  );
};

export default SuggestionsBlock;
